// extracted by mini-css-extract-plugin
export default {"paragraph":"style-module--paragraph--KwVwm","btnBilling":"style-module--btnBilling--mPQ-Q"};